/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Sort_By_Due_Date_AriaInputs */

const en_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const fr_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const de_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const it_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const ru_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const es_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const zh_cn2_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const ja_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const hi_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

const pt_pt2_explorer_table_sort_by_due_date_aria = /** @type {(inputs: Explorer_Table_Sort_By_Due_Date_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by due date`)
};

/**
* | output |
* | --- |
* | "Sort by due date" |
*
* @param {Explorer_Table_Sort_By_Due_Date_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_sort_by_due_date_aria = /** @type {((inputs?: Explorer_Table_Sort_By_Due_Date_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Sort_By_Due_Date_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "de") return de_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "it") return it_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "ru") return ru_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "es") return es_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "ja") return ja_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "hi") return hi_explorer_table_sort_by_due_date_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_sort_by_due_date_aria(inputs)
	return en_explorer_table_sort_by_due_date_aria(inputs)
});